import axios from '../../config/Axios/axios-instance';
import { Dispatch } from 'redux';
import { ListParams } from '../../hooks/useList/useList';
import {
  fetchOwnersFail,
  fetchOwnersStart,
  fetchOwnersSuccess,
  fetchUsersStart,
  fetchUsersSuccess,
  fetchUsersFail,
  createUserStart,
  createUserSuccess,
  createUserFail,
  updateUserStart,
  updateUserSuccess,
  updateUserFail,
  deleteUserStart,
  deleteUserSuccess,
  deleteUserFail,
  fetchCurrentUserStart,
  fetchCurrentUserSuccess,
  fetchCurrentUserFail,
  fetchMyDocumentsStart,
  fetchMyDocumentsFail,
  fetchMyDocumentsSuccess,
} from './actions';
import { API_URLS } from '../constants';
import { showToast } from '../../utility/toast/toast';
import { translate } from '../../utility/messageTranslator/translate';
import { IntlShape } from 'react-intl';
import { MainTaskSignStatus } from '../mainTask/service';

export type UserCreateRequest = {
  email: string;
  role: string;
  companyIds?: number[];
};

export type UserUpdateRequest = {
  id: number;
  email: string;
  role: string;
  companyIds?: number[];
};

export type SavedUserFilters = {
  search?: string;
  listName?: string;
  signStatus?: MainTaskSignStatus;
  archived?: boolean;
  limit?: number;
  page?: number;
};

export type GetOwnersListParams = ListParams & {
  companyId?: string;
};

export const fetchOwners =
  (params: GetOwnersListParams) => (dispatch: Dispatch) => {
    dispatch(fetchOwnersStart());
    return axios
      .get(`${API_URLS.user}/owners`, { params })
      .then((response) => {
        dispatch(fetchOwnersSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchOwnersFail(err?.response?.data?.error));
        showToast(err?.response?.data?.message, 'error');
      });
  };

export const fetchUsers = (params: ListParams) => (dispatch: Dispatch) => {
  dispatch(fetchUsersStart());
  return axios
    .get(API_URLS.user, { params })
    .then((response) => {
      dispatch(fetchUsersSuccess(response.data));
    })
    .catch((err) => {
      dispatch(fetchUsersFail(err?.response?.data?.error));
      showToast(err?.response?.data?.message, 'error');
    });
};

export const fetchMyDocuments =
  (params: ListParams) => (dispatch: Dispatch) => {
    dispatch(fetchMyDocumentsStart());
    return axios
      .get(`${API_URLS.user}/documents`, { params })
      .then((response) => {
        dispatch(fetchMyDocumentsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(fetchMyDocumentsFail(err?.response?.data?.error));
        showToast(err?.response?.data?.message, 'error');
      });
  };

export const createUser =
  (inputs: UserCreateRequest, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(createUserStart());
    return axios
      .post(API_URLS.user, {
        ...inputs,
      })
      .then((response) => {
        dispatch(createUserSuccess(response.data));
        showToast(translate(intl, 'SUCCESS.USER_CREATE'), 'success');
      })
      .catch((err) => {
        dispatch(createUserFail(err?.response?.data?.message));
      });
  };

export const updateUser =
  (inputs: UserUpdateRequest, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(updateUserStart());
    return axios
      .patch(`${API_URLS.user}/${inputs.id}`, {
        ...inputs,
      })
      .then(() => {
        dispatch(updateUserSuccess());
        showToast(translate(intl, 'SUCCESS.USER_UPDATE'), 'success');
      })
      .catch((err) => {
        dispatch(updateUserFail(err?.response?.data?.message));
      });
  };

export const deleteUser =
  (id: number, intl: IntlShape) => (dispatch: Dispatch) => {
    dispatch(deleteUserStart());
    return axios
      .delete(`${API_URLS.user}/${id}`)
      .then(() => {
        dispatch(deleteUserSuccess());
        showToast(translate(intl, 'SUCCESS.USER_DELETE'), 'success');
      })
      .catch((err) => {
        showToast(err?.response?.data?.message, 'error');
        dispatch(deleteUserFail(err?.response?.data?.message));
      });
  };

export const fetchCurrentUser = () => (dispatch: Dispatch) => {
  dispatch(fetchCurrentUserStart());

  return axios
    .get(`${API_URLS.user}/me`)
    .then((response) => {
      dispatch(fetchCurrentUserSuccess(response.data));
    })
    .catch((err) => {
      dispatch(fetchCurrentUserFail());
    });
};
